var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCanceled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.6971 0 0 10.6971 0 24C0 37.3029 10.6971 48 24 48C37.3029 48 48 37.3029 48 24C48 10.6971 37.1657 0 24 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6055 23.8625L30.034 20.434C30.7197 19.7482 30.7197 18.514 30.034 17.8283C29.3483 17.1425 28.114 17.1425 27.4283 17.8283L23.9997 21.2568L20.5712 17.8283C19.8854 17.1425 18.6512 17.1425 17.9655 17.8283C17.2797 18.514 17.2797 19.7482 17.9655 20.434L21.394 23.8625L17.9655 27.2911C17.2797 27.9768 17.2797 29.2111 17.9655 29.8968C18.6512 30.5825 19.8854 30.5825 20.5712 29.8968L23.9997 26.4682L27.4283 29.8968C28.114 30.5825 29.3483 30.5825 30.034 29.8968C30.7197 29.2111 30.7197 27.9768 30.034 27.2911L26.6055 23.8625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceled);
export default __webpack_public_path__ + "static/media/canceled.211c8ed4394464257f74a191bfa02b18.svg";
export { ForwardRef as ReactComponent };